import * as React from 'react';
import { Button, Col,  Container, FormGroup, Label, Modal  , Row} from 'reactstrap';
import { activateUser } from 'src/services';
import { Svg } from '../Svg';

interface IActivationConfirmationModalProps {
  isOpen: boolean;
  activationToken: string;
  toggleActivationConfirmationModal: () => void;
  toggleLoginModal: () => void;
}

export const ActivationConfirmationModal: React.SFC<
  IActivationConfirmationModalProps
  > = ({ isOpen, activationToken, toggleActivationConfirmationModal ,toggleLoginModal}) => {
  React.useEffect(() => {
    activateUser({ activationToken });
  });
  
  const doClick = () => {
    toggleActivationConfirmationModal();
    toggleLoginModal();
    }
 

  return (
    <Modal className='position-relative' isOpen={isOpen}>
      <Svg
        className='position-absolute'
        fill='primary'
        width={280}
        height={210}
        opacity={0.1}
        src='bulle-popin'
        style={{ top: '-19px', left: '-15px' }}
      />
      <div className='d-flex justify-content-end p-3'>
        <Svg
          fill='dark'
          src='close'
          width={16}
          onClick={toggleActivationConfirmationModal}
        />
      </div>
      <Container className='p-5'>
        <FormGroup>
          <Label className='d-flex flex-column'>
            <h4 className='align-self-center' >
            Votre compte a été activé avec succès !
            </h4>
          </Label>
          <Row className='d-flex justify-content-center'>
            <Col  xs='12'>
              <Button className='text-uppercase text-white bg-primary w-100 border-0 mt-3' onClick={doClick}>Connexion</Button>
            </Col>
          </Row>
        </FormGroup>
      </Container>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/Modals/ActivationConfirmationModal.tsx